import { Box, Container, Typography } from "@mui/material";
import React from "react";

export const SupportItem = ({ 
  iconPath = "/images/support/icon-personalized-support.svg", 
  iconAlt = "Support icon",
  title = "Personalized Support", 
  description = "Personalized support to help you understand your insurance coverage and financial options"
}) => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: "flex",
        justifyContent: "center",
        minHeight: { xs: "156px", md: "auto" },
        minWidth: { xs: "300px", md: "auto" },
        position: "relative",
        backgroundColor: "transparent",
      }}
      data-model-id="179:1888"
    >
      <Box
        sx={{
          width: "100%",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: { xs: "flex-start", md: "center" },
          gap: 0.5,
          padding: "0 20px",
          position: "relative",
          borderLeft: { xs: "none", md: "1px solid #d9dad9" },
          borderBottom: { xs: "0.5px solid #d9dad9", md: "none" },
        }}
      >
        <Box
          component="header"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: { xs: "center", md: "flex-start" },
            gap: { xs: "5px", md: "20px" },
            width: "100%",
            backgroundColor: "transparent",
          }}
        >
          <Box
            component="img"
            src={iconPath}
            alt={iconAlt}
            sx={{ 
              height: "60px",
              objectFit: "contain"
            }}
          />
          <Typography
            variant="h3"
            sx={{
              fontFamily: "'Plus Jakarta Sans', Helvetica",
              fontWeight: 800,
              color: "#0a404a",
              fontSize: "17px",
              lineHeight: "22px",
              textAlign: { xs: "left", md: "center" },
              width: "100%",
            }}
          >
            {title}
          </Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Plus Jakarta Sans', Helvetica",
            fontWeight: 400,
            color: "#0a404a",
            fontSize: "16px",
            lineHeight: "27px",
            textAlign: { xs: "left", md: "center" },
            width: "100%",
          }}
        >
          {description}
        </Typography>
      </Box>
    </Container>
  );
};